import script from "./ui-game-info-end.vue?vue&type=script&setup=true&lang=js"
export * from "./ui-game-info-end.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__